import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { ReactSortable } from "react-sortablejs";
import { focusElement } from "../lib/focusElement";
import {
  currentFieldsAtom,
  currentIndexAtom,
  fieldObjectsActionAtom,
  fieldObjectsAtom,
  fieldsActionAtom,
} from "../state/global.state";

export const Fields = () => {
  const [fieldObjects] = useAtom(fieldObjectsAtom);
  const [currentIndex] = useAtom(currentIndexAtom);
  const [fieldsAction, setFieldsAction] = useAtom(fieldsActionAtom);
  const [fieldObjectsAction] = useAtom(fieldObjectsActionAtom);

  const [currentFields, setCurrentFields] = useAtom(currentFieldsAtom);
  // const [currentFields, setCurrentFields] = useState<Field[]>([]);

  useEffect(() => {
    if (fieldObjects.length > 0) {
      setCurrentFields(() => fieldObjects[currentIndex].fields);
    }
  }, [currentIndex, fieldObjectsAction]);

  useEffect(() => {
    setFieldsAction(!fieldsAction);
  }, [currentFields]);

  return (
    <div id="list-container" className="flex gap-5">
      <ReactSortable list={currentFields} setList={setCurrentFields} className="!hidden lg:!flex">
        {currentFields.length > 0 &&
          currentFields.map((item, index) => {
            const removeHandler = () => {
              const result = confirm("Delete?");
              if (result) {
                const removedFields = currentFields.filter((field) => {
                  return field.id !== item.id;
                });
                setCurrentFields(() => removedFields);
              }
            };
            return (
              <div key={item.id} className="relative flex flex-col gap-3 items-start min-w-[140px] md:min-w-[260px]">
                {currentFields.length > 1 && (
                  <button
                    onClick={() => {
                      removeHandler();
                    }}
                    onTouchStart={() => {
                      removeHandler();
                    }}
                    className="absolute -top-[12px] -right-[12px] !w-[30px] !h-[30px] btn btn-circle min-h-0 flex justify-center items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3 w-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
                <div className="flex flex-col gap-4 w-full">
                  <input
                    type="text"
                    placeholder="before text"
                    className="input input-bordered input-{property} w-full max-w-xs"
                    id={`${item.id}_before`}
                    name={`${item.id}_before`}
                    value={item.before}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].before = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_before`);
                    }}
                  />
                  <textarea
                    className="textarea textarea-bordered min-h-[200px] md:min-h-[400px] w-full"
                    placeholder="list text"
                    id={`${item.id}_value`}
                    name={`${item.id}_value`}
                    value={item.value}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].value = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_value`);
                    }}
                  ></textarea>
                  <input
                    type="text"
                    placeholder="after text"
                    className="input input-bordered input-{property} w-full max-w-xs"
                    id={`${item.id}_after`}
                    name={`${item.id}_after`}
                    value={item.after}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].after = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_after`);
                    }}
                  />
                </div>
              </div>
            );
          })}
      </ReactSortable>
      <div className="flex lg:!hidden gap-5">
        {currentFields.length > 0 &&
          currentFields.map((item, index) => {
            const removeHandler = () => {
              const result = confirm("Delete?");
              if (result) {
                const removedFields = currentFields.filter((field) => {
                  return field.id !== item.id;
                });
                setCurrentFields(() => removedFields);
              }
            };
            return (
              <div key={item.id} className="relative flex flex-col gap-3 items-start min-w-[140px] md:min-w-[260px]">
                {currentFields.length > 1 && (
                  <button
                    onClick={() => {
                      removeHandler();
                    }}
                    onTouchStart={() => {
                      removeHandler();
                    }}
                    className="absolute -top-[12px] -right-[12px] !w-[30px] !h-[30px] btn btn-circle min-h-0 flex justify-center items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3 w-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
                <div className="flex flex-col gap-4 w-full">
                  <input
                    type="text"
                    placeholder="before text"
                    className="input input-bordered input-{property} w-full max-w-xs"
                    id={`${item.id}_before`}
                    name={`${item.id}_before`}
                    value={item.before}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].before = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_before`);
                    }}
                  />
                  <textarea
                    className="textarea textarea-bordered min-h-[200px] md:min-h-[400px] w-full"
                    placeholder="list text"
                    id={`${item.id}_value`}
                    name={`${item.id}_value`}
                    value={item.value}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].value = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_value`);
                    }}
                  ></textarea>
                  <input
                    type="text"
                    placeholder="after text"
                    className="input input-bordered input-{property} w-full max-w-xs"
                    id={`${item.id}_after`}
                    name={`${item.id}_after`}
                    value={item.after}
                    onChange={(e) => {
                      const newFields = [...currentFields];
                      newFields[index].after = e.target.value;
                      setCurrentFields(() => newFields);
                    }}
                    onTouchStart={() => {
                      focusElement(`${item.id}_after`);
                    }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
